module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0033.jpg?v=54006017";